import { StockListResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { DietaryDisplayList } from "../../../components/dietaryDisplayList/DietaryDisplayList";
import { buildDietaryList } from "../../../components/dietaryDisplayList/buildDietaryList";

export default function CategoryPageDietaryTypes({
  child,
  parent,
}: {
  child: StockListResponseType[number]["Products"][number];
  parent: StockListResponseType[number];
}): ReactElement | null {
  const dietaryList = buildDietaryList({
    childProduct: child,
    parentProduct: parent,
  });

  if (child.type === "badge") return null;

  return (
    <DietaryDisplayList
      dietaryRequirements={{
        LF: dietaryList.includes("LF"),
        VG: dietaryList.includes("VG"),
        GF: dietaryList.includes("GF"),
      }}
      mode="text"
    />
  );
}
